import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './auth-interceptor';
import { enterpriseInterceptor } from './enterprise-interceptor';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideTranslateService, provideTranslateLoader } from '@ngx-translate/core';
import { StaticTranslateLoader } from './i18n';

// 重新部署后旧标签页的懒加载 chunk（哈希名）已失效，点击菜单跳转会拉不到 chunk → 页面不更新/内容不对。
// 侦测这类 chunk 加载失败即自动刷新（10s 内至多一次，防循环）；刷新后拿到全新 index.html + chunk，跳转即恢复。
function reloadOnStaleChunk(error: unknown): void {
  const msg = String((error as { message?: string })?.message ?? error ?? '');
  if (!/ChunkLoadError|dynamically imported module|module script failed|Failed to fetch|Loading chunk/i.test(msg)) {
    return;
  }
  try {
    const last = Number(sessionStorage.getItem('chunkReloadAt') || 0);
    if (Date.now() - last > 10000) {
      sessionStorage.setItem('chunkReloadAt', String(Date.now()));
      location.reload();
    }
  } catch {
    /* SSR/无 storage：忽略 */
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withNavigationErrorHandler((e) => reloadOnStaleChunk(e))),
    // SSR/Workers 用 Fetch（避免 xhr2 的 createRequire 崩溃）；authInterceptor 注入 Bearer + 401 静默刷新，
    // enterpriseInterceptor 注入 X-Enterprise-Id 使全部请求按选中企业隔离。
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, enterpriseInterceptor])),
    provideClientHydration(withEventReplay()),
    // 多语言：英/德/台湾繁体，内存静态字典加载器（无 HTTP），默认回退 en。
    provideTranslateService({
      loader: provideTranslateLoader(StaticTranslateLoader),
      fallbackLang: 'en',
    }),
  ],
};
